<template>
    <b-row class="presentation-section" align-h="start">
        <b-col lg="8" md="8" cols="12" class="pb-5">
            <div class="presentation-image-container">
                <!-- <img src="@/assets/images/dummy-presentation.png" alt=""> -->
                <!-- <iframe width="560" height="315" :src="videoUrl" frameborder="0" allowfullscreen></iframe> -->
                <!-- @/assets/images/instagram.png -->
                <video width="560" height="315" controls autoplay>
                    <source src="@/assets/videos/GoxPuntos.mp4" type="video/mp4">
                    Tu navegador no soporta el elemento video.
                </video>
            </div>
        </b-col>
        <b-col lg="4" md="4" cols="12" class="presentation-content">
            <b-row>
                <b-col cols="11" class="mx-auto">
                    <p class="presentation-titulo"  v-html="content.titulo"></p>
                    <p class="presentation-subtitulo"  v-html="content.subtitulo"></p>

                    <!-- <p class="presentation-content-title"  v-html="content.content"></p> -->
                    <div class="mt-5 pb-5">
                        <a :href="videoUrl" target="_blank">
                            <button class="button-primary-associate">
                                <span class="button-text-associate pr-4">{{content.button}}
                                 
                                </span>
                            </button>
                        </a>

                    </div>
                </b-col>
            </b-row>
        </b-col>
      
    </b-row>
</template>
<script>

    import configs  from '../../local_config';

    export default {
        name: 'section-presentation',
        components: {},
        props: {
            content: Object
        },
        data: () => ({
            videoUrl : configs.SECTION_PRESENTATION_VIDEO,
            // videoSrc: "../../assets/videos/GoxPuntos.mp4"
            // embedCode: `<iframe width="560" height="315" src="https://www.youtube.com/embed/{W2MjUKVhjqUasjgc}" frameborder="0" allowfullscreen></iframe>`
        }),
        created: function () {
            var self = this;
            setInterval(function () {
                if(self.settings){
                    self.settings.rtl = !self.settings.rtl
                }
               
            }, 15000);
        },
        methods: {
            showNext() {
                this.$refs.carousel.next()
            },
            goRouter(url) {
                this.$router.push(url)
            },
            redirectNewWindow() {
                window.location.href = `${configs.SECTION_PRESENTATION_VIDEO}`;
            }
        }
    }
</script>
<style scoped>

@media (max-width: 600px) {
    .presentation-section{
        margin-top: 550px;
        background-color: #6A73CA;
        justify-content: center;
        align-items: center;
    }

    .presentation-content{
        text-align: center;
    }
    
}

</style>